import { combineReducers } from "@reduxjs/toolkit";
import { connectRouter } from "connected-react-router";
import storeAuthenticateReducer from "../reducers/authenticate.reducer";

export const rootReducer = (history) =>
  combineReducers({
    storeHistoryReducer: connectRouter(history),
    storeAuthenticateReducer: storeAuthenticateReducer,
  });
